import { render, staticRenderFns } from "./PopUnifiedDiscountSettingsDialog.vue?vue&type=template&id=5bd4dd51&scoped=true&"
import script from "./PopUnifiedDiscountSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./PopUnifiedDiscountSettingsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PopUnifiedDiscountSettingsDialog.vue?vue&type=style&index=0&id=5bd4dd51&lang=scss&scoped=true&"
import style1 from "./PopUnifiedDiscountSettingsDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4dd51",
  null
  
)

export default component.exports